<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11NnGsd/tc-custom/9781480451742.jpg?1702846313161" alt="This image is the cover for the book Party's Over"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Party's Over
      </h1>
      <p class="bookDescription body article font2">
        <b>The most popular girl in her class has to cope with hard truths after high school graduation as she wonders, Now what?</b><br/>Prom queen. Captain of the cheerleading squad. Girlfriend of the most popular guy in school. Westerly High senior Helen Miranda Revness—Hallie to her friends—has it all. She just wishes everyone would stop talking about where they’re going to college—and asking her why she’s not applying to schools. Hallie has zero interest in four more years of teachers and term papers.<br/>After graduation and an unforgettable summer of parties and romance, everyone—including her boyfriend, Jaz—heads off to college. Hallie is no longer part of a couple or a crowd. Her family, in which she had to grow up fast, is more chaotic and scattered than ever. She tries to get a job, but discovers that a high school diploma will only take her so far. After a shattering heartbreak, she finally has to confront the reality of who she is and where she’s going.<br/>“This sensitive picture of a young woman coming to terms with hard truths about adulthood and growing up in the process is well populated with believable characters. An involving . . . depiction of what it means to rethink basic values.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caroline B. Cooney
      </h2>
      
      <p class="authorDescription body article">Caroline B. Cooney (b. 1947) is the author of nearly a hundred books, including the famed young adult thriller<i> The Face on the Milk Carton</i>, an international bestseller<i>. </i>Cooney&rsquo;s books have been translated into several languages, and have received multiple honors and awards, including an American Library Association Best Book for Young Adults award and a nomination for the Edgar Allan Poe Award. She is best known for her popular teen horror thrillers and romance novels. Her fast-paced, plot-driven work often explores themes of good and evil, love and hatred, right and wrong, and moral ambiguity. Born in Geneva, New York, Cooney grew up in Connecticut, and often sets her novels in dramatic New England landscapes. She has three children and four grandchildren and currently lives in South Carolina. &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?529a754e